import _defineProperty from "/ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

var _defaultSpecifiers;

import { array, error, extend, hasOwnProperty } from 'vega-util';
export var YEAR = 'year';
export var QUARTER = 'quarter';
export var MONTH = 'month';
export var WEEK = 'week';
export var DATE = 'date';
export var DAY = 'day';
export var DAYOFYEAR = 'dayofyear';
export var HOURS = 'hours';
export var MINUTES = 'minutes';
export var SECONDS = 'seconds';
export var MILLISECONDS = 'milliseconds';
export var TIME_UNITS = [YEAR, QUARTER, MONTH, WEEK, DATE, DAY, DAYOFYEAR, HOURS, MINUTES, SECONDS, MILLISECONDS];
var UNITS = TIME_UNITS.reduce(function (o, u, i) {
  return o[u] = 1 + i, o;
}, {});
export function timeUnits(units) {
  var u = array(units).slice(),
      m = {}; // check validity

  if (!u.length) error('Missing time unit.');
  u.forEach(function (unit) {
    if (hasOwnProperty(UNITS, unit)) {
      m[unit] = 1;
    } else {
      error("Invalid time unit: ".concat(unit, "."));
    }
  });
  var numTypes = (m[WEEK] || m[DAY] ? 1 : 0) + (m[QUARTER] || m[MONTH] || m[DATE] ? 1 : 0) + (m[DAYOFYEAR] ? 1 : 0);

  if (numTypes > 1) {
    error("Incompatible time units: ".concat(units));
  } // ensure proper sort order


  u.sort(function (a, b) {
    return UNITS[a] - UNITS[b];
  });
  return u;
}
var defaultSpecifiers = (_defaultSpecifiers = {}, _defineProperty(_defaultSpecifiers, YEAR, '%Y '), _defineProperty(_defaultSpecifiers, QUARTER, 'Q%q '), _defineProperty(_defaultSpecifiers, MONTH, '%b '), _defineProperty(_defaultSpecifiers, DATE, '%d '), _defineProperty(_defaultSpecifiers, WEEK, 'W%U '), _defineProperty(_defaultSpecifiers, DAY, '%a '), _defineProperty(_defaultSpecifiers, DAYOFYEAR, '%j '), _defineProperty(_defaultSpecifiers, HOURS, '%H:00'), _defineProperty(_defaultSpecifiers, MINUTES, '00:%M'), _defineProperty(_defaultSpecifiers, SECONDS, ':%S'), _defineProperty(_defaultSpecifiers, MILLISECONDS, '.%L'), _defineProperty(_defaultSpecifiers, "".concat(YEAR, "-").concat(MONTH), '%Y-%m '), _defineProperty(_defaultSpecifiers, "".concat(YEAR, "-").concat(MONTH, "-").concat(DATE), '%Y-%m-%d '), _defineProperty(_defaultSpecifiers, "".concat(HOURS, "-").concat(MINUTES), '%H:%M'), _defaultSpecifiers);
export function timeUnitSpecifier(units, specifiers) {
  var s = extend({}, defaultSpecifiers, specifiers),
      u = timeUnits(units),
      n = u.length;
  var fmt = '',
      start = 0,
      end,
      key;

  for (start = 0; start < n;) {
    for (end = u.length; end > start; --end) {
      key = u.slice(start, end).join('-');

      if (s[key] != null) {
        fmt += s[key];
        start = end;
        break;
      }
    }
  }

  return fmt.trim();
}